<script>
    import { onMount } from "svelte";

    import { CardLayout } from "../../../Components/Common/index.svelte";

    import PieChart from "../../../Components/Charts/PieChart.svelte";

    import { getRatioPercentageValue } from "../../../Utils/utilFunctions.svelte";

    export let statuses = {};

    let isParsingData = true,
        chartData = [],
        chartLabels = [];

    let chartColors = [
        "rgba(251, 60, 186, 0.8)",
        "rgba(251, 212, 8, 1)",
        "rgba(7, 208, 3, 1)",
        "rgba(20, 184, 194, 1)",
        "rgba(97, 20, 194, 1)",
        "rgba(20, 90, 194, 1)",
        "rgba(30, 40, 130, 1)",
    ];

    onMount(() => {
        statuses && parseData();
    });

    const parseData = async () => {
        const entries = Object.entries(statuses);

        let sum = 0;

        for (const [key, value] of entries) {
            sum += value;
        }

        for (const [key, value] of entries) {
            chartLabels.push(key);
            chartData.push(getRatioPercentageValue(value, sum));
        }

        isParsingData = false;
    };
</script>

<div class="flex flex-1 flex-col p-6">
    {#if isParsingData}
        <div class="flex-1 items-center text-center">Parsing chart data</div>
    {:else if !chartData}
        <div class="flex-1 items-center text-center">Nothing to display</div>
    {:else}
        <PieChart
            isResponsive={false}
            width="50"
            height="150px"
            backgroundColorArr={chartColors}
            {chartData}
            labels={chartLabels}
        />
    {/if}
</div>
